import { Consent, userHasOptedOutOfCookiesForCategory } from './consent'

const ga = (...args: any) => {
  if (
    typeof window !== 'undefined' &&
    typeof (window as any).ga === 'function'
  ) {
    const userHasOptedOutOfCookiesForGA = userHasOptedOutOfCookiesForCategory(
      Consent.statistics
    )
    // only call ga when user hasn't opted out
    if (!userHasOptedOutOfCookiesForGA) {
      ;(window as any).ga(...args)
    }
  }
}

export default ga
